import { Injectable } from '@angular/core';
import { LogisticaRepository } from './logistica.repository';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { getOperationsLogisticsResponse } from '../registro-operacion/domain/registro-operacion.response';
import { cancelOperationLogisticRequest, getOperationsLogisticsRequest } from '../registro-operacion/domain/registro-operacion.request';
import { generalTransaccionResponse } from 'src/app/shared/domain/shared.request';
import { D_ProformaCorreoRequest, envioCorreoProformaRequest, FirmaResponse, formatoDocumentosRequest, getCntrAduanaRequest, getDocumentosAgenciamientoRequest, getOperationsAgenciamientoRequest, getProformaAgenciamientoRequest, getTarifasPorCodigoRequest, guardarAgenciaAduanaDetallesRequest, GuardarProgramacionControlesRequest, GuardarServiciosProformaRequest, ObtenerFirmaRequest, ObtenerProgramacionControlesDTO, ObtenerProgramacionControlesRequest, ObtenerServiciosProformaRequest, ServicioProformaDTO, ServiciosAsociadosRequest, solicitarDocumentosRequest, tnsCntrAduanaRequest, tnsDocumentosAgenciamientoRequest, tnsProformaAgenciamientoRequest } from '../gestion-agenciamiento-aduana/domain/gestion-agenciamiento-aduana.request';
import { ApiResponse, envioCorreoDocumentosResponse, envioCorreoProformaResponse, getCntrAduanaResponse, getFormatoCorreoAduanaResponse, getItemsAgeDocumentosDTO, getOperationsAgenciamientoResponse, getProformaAgenciamientoResponse, getTarifasPorCodigoResponse, ServiciosAsociadosDTO, TnsAgenciamientoDetallesResponse, tnsCntrAduanaResponse, tnsDocsAduanaResponse, tnsProformaAgenciamientoResponse } from '../gestion-agenciamiento-aduana/domain/gestion-agenciamiento-aduana.response';
import { ListarTarifaCotizacionRequest } from 'src/app/comercial/orden-venta/domain/request/comercial-orden-venta-request';
import { ListarTarifaCotizacionResponse } from 'src/app/comercial/orden-venta/domain/response/comercial-orden-venta-response';
import { getDireccionesRequest, getRutaByPlaceRequest, getZoneByProviderRequest, managementDireccionesRequest, managementRutasRequest, managementTypeRequest, managementZonaProveedorRequest } from '../gestion-transporte/domain/gestion-transporte.request';
import { getOtrosOpeResponse, guardarOpeOtrosResponse, } from '../gestion-otros/domain/gestion-otros.response';
import { getOtrosOpeRequest, guardarOtrosRequest, } from '../gestion-otros/domain/gestion-otros.request';

@Injectable({
  providedIn: 'root'
})
export class LogisticaService extends LogisticaRepository {

  constructor(
    private readonly http: HttpClient
  ) {
    super()
  }

  override getOperationsLogistics(request: getOperationsLogisticsRequest): Observable<getOperationsLogisticsResponse> {
    return this.http.post<getOperationsLogisticsResponse>(`${environment.PATH_API}/logistic/getOperationsLogistics`, request)
  }

  override cancelOperationLogistic(request: cancelOperationLogisticRequest): Observable<generalTransaccionResponse> {
    return this.http.post<generalTransaccionResponse>(`${environment.PATH_API}/logistic/cancelOperationLogistic`, request)
  }

  //#region AGENCIAMIENTO
  override getOperationsAgenciamiento(request: getOperationsAgenciamientoRequest): Observable<getOperationsAgenciamientoResponse> {
    return this.http.post<getOperationsAgenciamientoResponse>(`${environment.PATH_API}/logistic/getOperationAgenciamiento`, request)
  }
  override guardarAgenciaAduanaDetalles(request: guardarAgenciaAduanaDetallesRequest): Observable<TnsAgenciamientoDetallesResponse> {
    return this.http.post<TnsAgenciamientoDetallesResponse>(`${environment.PATH_API}/logistic/guardarAgenciaAduanaDetalles`, request)
  }
  override listarDocumentosAduana(request: getDocumentosAgenciamientoRequest): Observable<getItemsAgeDocumentosDTO> {
    return this.http.post<getItemsAgeDocumentosDTO>(`${environment.PATH_API}/logistic/listarDocsAduana`, request)
  }
  override getCorreoSolicitudDocumentos(request: formatoDocumentosRequest): Observable<getFormatoCorreoAduanaResponse> {
    return this.http.post<getFormatoCorreoAduanaResponse>(`${environment.PATH_API}/logistic/getCorreoSolicitudDocumentos`, request)
  }
  override envioCorreoSolicitudDocumentos(request: solicitarDocumentosRequest): Observable<envioCorreoDocumentosResponse> {
    return this.http.post<envioCorreoDocumentosResponse>(`${environment.PATH_API}/logistic/envioCorreoSolicitudDocumentos`, request)
  }
  override tnsDocumentosAduana(request: tnsDocumentosAgenciamientoRequest): Observable<tnsDocsAduanaResponse> {
    return this.http.post<tnsDocsAduanaResponse>(`${environment.PATH_API}/logistic/transaccionDocsAduana`, request)
  }
  override listarProforma(request: getProformaAgenciamientoRequest): Observable<getProformaAgenciamientoResponse> {
    return this.http.post<getProformaAgenciamientoResponse>(`${environment.PATH_API}/logistic/getProformaAgenciamiento`, request)
  }
  override tnsProformaAgenciamiento(request: tnsProformaAgenciamientoRequest): Observable<tnsProformaAgenciamientoResponse> {
    return this.http.post<tnsProformaAgenciamientoResponse>(`${environment.PATH_API}/logistic/tnsProformaAgenciamiento`, request)
  }
  override envioCorreoProforma(request: envioCorreoProformaRequest): Observable<envioCorreoProformaResponse> {
    return this.http.post<envioCorreoProformaResponse>(`${environment.PATH_API}/logistic/envioCorreoProformaAgenciamiento`, request)
  }
  override ObtenerServiciosAsociados(request: ServiciosAsociadosRequest): Observable<ApiResponse<ServiciosAsociadosDTO>> {
    return this.http.post<ApiResponse<ServiciosAsociadosDTO>>(`${environment.PATH_API}/logistic/obtenerServiciosAsociados`, request)
  }
  ListarTarifas(request: ListarTarifaCotizacionRequest): Observable<ListarTarifaCotizacionResponse> {
    return this.http.post<ListarTarifaCotizacionResponse>(`${environment.PATH_API}/comercial/ListarTarifasCotizacion`, request);
  }
  override listarTarifasPorCodigo(request: getTarifasPorCodigoRequest): Observable<getTarifasPorCodigoResponse> {
    return this.http.post<getTarifasPorCodigoResponse>(`${environment.PATH_API}/logistic/getTarifasByCodigo`, request);
  }
  override GuardarServiciosProforma(request: GuardarServiciosProformaRequest): Observable<ApiResponse<null>> {
    return this.http.post<ApiResponse<null>>(`${environment.PATH_API}/logistic/guardarServiciosProforma`, request)
  }
  override ObtenerServiciosProforma(request: ObtenerServiciosProformaRequest): Observable<ApiResponse<ServicioProformaDTO>> {
    return this.http.post<ApiResponse<ServicioProformaDTO>>(`${environment.PATH_API}/logistic/obtenerServiciosProforma`, request)
  }
  override ObtenerProgramacionControles(request: ObtenerProgramacionControlesRequest): Observable<ApiResponse<ObtenerProgramacionControlesDTO>> {
    return this.http.post<ApiResponse<ObtenerProgramacionControlesDTO>>(`${environment.PATH_API}/logistic/obtenerProgramacionControles`, request)
  }
  override GuardarProgramacionControles(request: GuardarProgramacionControlesRequest): Observable<ApiResponse<null>> {
    return this.http.post<ApiResponse<null>>(`${environment.PATH_API}/logistic/guardarProgramacionControles`, request)
  }
  override EnviarCorreoProforma(request: D_ProformaCorreoRequest): Observable<ApiResponse<null>> {
    return this.http.post<ApiResponse<null>>(`${environment.PATH_API}/logistic/enviarCorreoProforma`, request)
  }
  override obtenerFirmaUsuario(request: ObtenerFirmaRequest): Observable<{ firmaUrl: string | null, chatbotUrl: string | null, mensaje: string | null }> {
    return this.http.post<ApiResponse<FirmaResponse>>(`${environment.PATH_API}/logistic/obtenerFirmaUsuario`, request).pipe(
      map(response => {
        // defensa: asegurarnos que result sea un array
        const resultArray: FirmaResponse[] = Array.isArray(response.datos.result) ? response.datos.result as FirmaResponse[] : [];

        const firmaBase64 = response.datos.result.find(img => img.nombre === 'firma')?.base64;
        const chatbotBase64 = response.datos.result.find(img => img.nombre === 'chatbot')?.base64;

        // Construye las Data URLs
        const firmaUrl = firmaBase64 ? `data:image/png;base64,${firmaBase64}` : null;
        const chatbotUrl = chatbotBase64 ? `data:image/png;base64,${chatbotBase64}` : null;

        return { firmaUrl, chatbotUrl, mensaje: response.meta?.mensaje ?? '' };
      })
    );
  }
  override getOperacionesOtros(request: getOtrosOpeRequest): Observable<getOtrosOpeResponse> {
    return this.http.post<getOtrosOpeResponse>(`${environment.PATH_API}/logistic/getOperacionesOtros`, request)
  }
  override saveOperacionesOtros(request: guardarOtrosRequest): Observable<guardarOpeOtrosResponse> {
    return this.http.post<guardarOpeOtrosResponse>(`${environment.PATH_API}/logistic/saveOperacionesOtros`, request)
  }
  override getListadoCntrAduana(request: getCntrAduanaRequest): Observable<getCntrAduanaResponse> {
    return this.http.post<getCntrAduanaResponse>(`${environment.PATH_API}/logistic/getContenedoresAgenciamiento`, request)
  }
  override tnsCntrAduana(request: tnsCntrAduanaRequest): Observable<tnsCntrAduanaResponse> {
    return this.http.post<tnsCntrAduanaResponse>(`${environment.PATH_API}/logistic/tnsContenedoresAgenciamiento`, request)
  }
  //#endregion

  override managementType(request: managementTypeRequest): Observable<generalTransaccionResponse> {
    return this.http.post<generalTransaccionResponse>(`${environment.PATH_API}/logistic/managementType`, request)
  }
  override getZoneByProvider(request: getZoneByProviderRequest): Observable<any> {
    return this.http.post<any>(`${environment.PATH_API}/logistic/getZoneByProvider`, request)
  }
  override getRutaByPlace(request: getRutaByPlaceRequest): Observable<any> {
    return this.http.post<any>(`${environment.PATH_API}/logistic/getRutaByPlace`, request)
  }
  override managementRutas(request: managementRutasRequest): Observable<generalTransaccionResponse> {
    return this.http.post<generalTransaccionResponse>(`${environment.PATH_API}/logistic/managementRutas`, request)

  }

  override getDirecciones(request: getDireccionesRequest): Observable<any> {
    return this.http.post<any>(`${environment.PATH_API}/logistic/getDirecciones`, request)
  }

  override managementDirecciones(request: managementDireccionesRequest): Observable<generalTransaccionResponse> {
    return this.http.post<generalTransaccionResponse>(`${environment.PATH_API}/logistic/managementDirecciones`, request)
  }

  override managementZonaProveedor(request: managementZonaProveedorRequest): Observable<generalTransaccionResponse> {
    return this.http.post<generalTransaccionResponse>(`${environment.PATH_API}/logistic/managementZonaProveedor`, request)

  }
}
